import { gql } from 'graphql-request'

export const lastVideoQuery = () => gql`
  query fetchLastVideo($slug: String!) {
    fetchLastVideoWatched(collection: $slug) {
      content {
        slug
      }

      isSeries
    }
  }
`

export const mapToLastVideoData = (data: any) => {
  return data.fetchLastVideoWatched as {
    content: {
      slug: string
    }
    isSeries: boolean
  }
}
